export default __webpack_public_path__ + "static/media/info-x.icon.e1f43444.svg";